import script from "./ObligationsAssistant.vue?vue&type=script&setup=true&lang=js"
export * from "./ObligationsAssistant.vue?vue&type=script&setup=true&lang=js"

import "./ObligationsAssistant.vue?vue&type=style&index=0&id=528bee84&lang=scss"

const __exports__ = script;

export default __exports__